var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"duplicate-discount"},[_c('PBackButton',{staticClass:"container"}),_c('CDiscountForm',{attrs:{"from-active":_vm.active}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }